import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Grid,
	Tooltip,
	Button
} from '@material-ui/core';

import CircledIconButton from "./CircledIconButton";
import ActionButton from './ActionButton';

const styles = makeStyles(theme => ({
	tooltip: {
		maxWidth: 130
	}
}));

function ActivityActions(props) {
	let classes = styles(),
		primaryActions = [],
		{actions} = props;

	if (actions && actions.length) {
		actions.map((action, index) => {
			let button = (
				<ActionButton action={action} />
			);

			return (
				primaryActions.push(
					<Grid item key={action.label} style={{width: '50%'}}>
						{action.tooltip && !action.disabled ?
							<Tooltip
								placement="top"
								disableFocusListener
								title={action.tooltip}
								classes={{tooltip: classes.tooltip}}>
								{button}
							</Tooltip> : button
						}
					</Grid>
				)
			);
		});
	}

	return (
		<Grid
			container
			direction="row"
			spacing={1}>
			{primaryActions}
		</Grid>
	);
}

ActivityActions.propTypes = {
	actions: PropTypes.array
};

export default ActivityActions;


//(action.primary === true ? (

/*) : (
	menuActions.push(
		<MenuItem key={action.label} onClick={(event) => {action.handleClick(); this.menuClose();}}>
			<FontAwesomeIcon
				className={classes.menuIcon}
				icon={action.icon}
				rotation={action.iconRotation}
				size="xs"
				title={`${action.label} Activity`} /> {action.label}
		</MenuItem>
	)
))*/